export default {
  Entities: {
    Table: {
      Headers: {
        ENTITY: 'Entity Name',
        COUNTRY: 'Country / Currency',
        HEADCOUNT: 'Headcount',
      },
    },
    AwaitingImport: {
      TITLE: 'Hold tight',
      data: {
        BODY: 'We\'re still collecting the data we need for you to create your recharge rules. We\'ll send you an email once it\'s completed. This is normally within 10 minutes, but can be longer if there\'s lots of data in your organisations.',
      },
      transactions: {
        BODY: 'We\'re still collecting the data we need for you to run recharge calculations. We\'ll send you an email once it\'s completed. This is normally within 1 hour, but can be longer if there\'s lots of transactions to import.',
      },
      TIME_REMAINING: 'Estimated time remaining:',
      MINUTES: ['{{count}} minute', '{{count}} minutes'],
    },
    Edit: {
      TITLE: 'Edit Entity Info',
      MESSAGE: 'Most data is sync\'d with Xero. Please edit that data in Xero and re-sync.',
      OPEN_XERO: 'Open Xero',
    },
    RateLimited: {
      TITLE: 'Rate Limited',
      NOTICE: 'This entity has reached Xero\'s Daily API Request Limit',
      DAILY: [
        '{{entities}} has reached Xero\'s Daily API Request limit.\n\nThis means that some data may be missing, and we cannot complete the sync until the rate limit clears on **{{clearTime}}**. Until then, you will also be unable to make any postings into Xero from Mayday.\n\nThis normally only happens in exceptional situations, such as during initial set up, and normally resolves itself once the rate limit expires.\n\nIf you have any questions, please feel free to reach out using the chat window in the bottom-right.',
        '{{entities}} have reached Xero\'s Daily API Request limit.\n\nThis means that some data may be missing, and we cannot complete the sync until the rate limit clears on **{{clearTime}}**. Until then, you will also be unable to make any postings into Xero from Mayday.\n\nThis normally only happens in exceptional situations, such as during initial set up, and normally resolves itself once the rate limit expires.\n\nIf you have any questions, please feel free to reach out using the chat window in the bottom-right.',
      ],
    },
  },
};
